<template>
  <div class="content">
    <div class="content__title content__title--party">
      <div class="content__title content__title--party content__title--start">
        <router-link :to="{ name: 'program' }" class="button button--light button--no-indent button--small">
          <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.70917 13.7082C7.61629 13.8013 7.50595 13.8752 7.38447 13.9256C7.263 13.976 7.13277 14.002 7.00125 14.002C6.86973 14.002 6.7395 13.976 6.61802 13.9256C6.49655 13.8752 6.38621 13.8013 6.29332 13.7082L0.293962 7.70884C0.200846 7.61595 0.126968 7.50562 0.0765611 7.38414C0.0261537 7.26266 0.000206594 7.13243 0.000206606 7.00091C0.000206617 6.86939 0.0261537 6.73916 0.0765611 6.61769C0.126969 6.49621 0.200846 6.38587 0.293962 6.29299L6.29333 0.293626C6.48108 0.105873 6.73573 0.00039471 7.00125 0.000394734C7.26677 0.000394757 7.52142 0.105873 7.70918 0.293626C7.89693 0.481379 8.00241 0.736028 8.00241 1.00155C8.00241 1.26707 7.89693 1.52172 7.70917 1.70948L2.41574 7.00091L7.70917 12.2923C7.80229 12.3852 7.87617 12.4956 7.92658 12.617C7.97698 12.7385 8.00293 12.8688 8.00293 13.0003C8.00293 13.1318 7.97698 13.262 7.92658 13.3835C7.87617 13.505 7.80229 13.6153 7.70917 13.7082Z" fill="#2B93E7"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16 7.00108C16 7.26627 15.8947 7.5206 15.7071 7.70811C15.5196 7.89563 15.2653 8.00098 15.0001 8.00098L2.00149 8.00098C1.7363 8.00098 1.48197 7.89563 1.29445 7.70811C1.10694 7.5206 1.00159 7.26627 1.00159 7.00108C1.00159 6.73589 1.10694 6.48156 1.29445 6.29405C1.48197 6.10653 1.7363 6.00119 2.00149 6.00119L15.0001 6.00119C15.2653 6.00119 15.5196 6.10653 15.7071 6.29405C15.8947 6.48157 16 6.73589 16 7.00108Z" fill="#2B93E7"/>
          </svg>
        </router-link>
        <h1 class="title title--big title--theme">Редактирование уведомления о реализации программ и проектов</h1>
      </div>
      <button v-if="userRole === 'admin'" @click="openSidebar" class="link" type="button">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 17.0134L11.413 16.9984L21.045 7.45839C21.423 7.08039 21.631 6.57839 21.631 6.04439C21.631 5.51039 21.423 5.00839 21.045 4.63039L19.459 3.04439C18.703 2.28839 17.384 2.29239 16.634 3.04139L7 12.5834V17.0134ZM18.045 4.45839L19.634 6.04139L18.037 7.62339L16.451 6.03839L18.045 4.45839ZM9 13.4174L15.03 7.44439L16.616 9.03039L10.587 15.0014L9 15.0064V13.4174Z" fill="#2B93E7"/>
          <path d="M5 21H19C20.103 21 21 20.103 21 19V10.332L19 12.332V19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.897 3 5V19C3 20.103 3.897 21 5 21Z" fill="#2B93E7"/>
        </svg>
        <span>Управление</span>
      </button>
    </div>

    <!-- Комментарии админа / отказа -->
    <div v-if="userRole === 'admin' && manage.comment_tech" class="comment"><div class="comment__info">{{ manage.comment_tech }}</div></div>
    <div v-if="userRole !== 'admin' && manage.comment_cancel" class="comment comment--warning">
      <div class="comment__info"><img src="@/assets/img/warning-icon.svg" alt="">{{ manage.comment_cancel }}</div>
    </div>

    <form class="form" @submit.prevent>
      <div class="form__content">
        <!-- Год (только админ) -->
        <div class="form__part" v-if="userRole === 'admin'">
          <div class="form-group">
            <label for="year">Год</label>
            <div class="form-control"><input id="year" type="text" class="form-control__input" v-model.trim="form.year" readonly /></div>
          </div>
        </div>

        <!-- Статус (только админ) -->
        <div class="form__part" v-if="userRole === 'admin'">
          <div class="form-group">
            <label>Статус<sup>*</sup></label>
            <v-select v-model="manage.status" :reduce="status => status.id" :options="status_options" :get-option-label="opt => opt.name" label="name" :searchable="false" :clearable="false" placeholder="Выберите статус" class="select">
              <template slot="open-indicator"><svg width="18" height="18" fill="none" class="open-indicator" xmlns="http://www.w3.org/2000/svg"><circle cx="9" cy="9" r="9" fill="#2b93e7"></circle><path d="M8.6 11.82L5.16 8.05a.66.66 0 010-.87.53.53 0 01.8 0L9 10.52l3.04-3.34a.53.53 0 01.8 0c.21.24.21.63 0 .87L9.4 11.82A.53.53 0 019 12a.53.53 0 01-.4-.18z" fill="#fff"></path></svg></template>
              <template slot="option" slot-scope="option"><div class="select__item d-center">{{ option.name }}</div></template>
              <template slot="selected-option" slot-scope="option"><div class="selected d-center">{{ option.name }}</div></template>
            </v-select>
          </div>
        </div>
      </div>

      <!-- Федеральные программы (простой список) -->
      <div class="form__part" v-if="programs.length">
        <div class="form-group">
          <label>Федеральные программы и проекты РСМ</label>
          <div class="form__element" v-for="item in programs" :key="item.id">
            <label class="checkbox">
              <div class="checkbox__text">{{ item.name }}</div>
              <input type="checkbox" v-model="form.program" :value="item.id" />
              <div class="checkbox__checkmark"></div>
            </label>
          </div>
        </div>
      </div>
      <div v-else class="form__empty"><p>Программы не найдены</p></div>

      <!-- Программы и проекты РО РСМ -->
      <div class="form__part">
        <div class="form-group">
          <label for="ro_programs">Программы и проекты РО РСМ</label>
          <textarea id="ro_programs" v-model.trim="form.ro_programs" class="form-control__input" rows="4" placeholder="Введите названия программ и проектов вашей региональной организации"></textarea>
        </div>
      </div>

      <!-- Кнопки -->
      <div class="holder holder--end">
        <button v-if="userRole !== 'admin' && form.status === 'draft'" @click="onSendForm('draft')" class="button button--gray" type="button" :class="{ 'preload': loading }"><span>Сохранить черновик</span><img src="@/assets/img/preloader.svg" alt="" class="button__preloader"/></button>
        <button v-if="userRole !== 'admin' && (form.status === 'draft' || form.status === 'rejected')" @click="onSendForm('review')" class="button" type="button" :class="{ 'preload': loading }"><span>Отправить на проверку</span><img src="@/assets/img/preloader.svg" alt="" class="button__preloader"/></button>
        <button v-if="userRole === 'admin'" @click="onSendForm(form.status)" class="button" type="submit" :class="{ 'preload': loading }"><span>Сохранить изменения</span><img src="@/assets/img/preloader.svg" alt="" class="button__preloader"/></button>
      </div>
    </form>

    <!-- Sidebar управления -->
    <SidebarManage :title="'Управление'" :class="{'sidebar-manage--full': show_sidebar}" @close-sidebar="show_sidebar = false">
      <form @submit.prevent>
        <div class="form-group"><label for="comment_tech">Служебный комментарий</label><div class="form-control"><textarea @change="sendManage" id="comment_tech" name="comment_tech" class="form-control__textarea" v-model.trim="manage.comment_tech" placeholder="Видят только администраторы"></textarea></div></div>
        <div class="form-group"><label for="comment_cancel">Комментарий отказа</label><div class="form-control"><textarea @change="sendManage" id="comment_cancel" name="comment_cancel" class="form-control__textarea" v-model.trim="manage.comment_cancel" placeholder="Видит РО на анкете со статусом 'Отклонена'"></textarea></div></div>
      </form>
      <div class="sidebar-card">
        <div class="sidebar-card__item sidebar-card__item--between"><b>Дата создания</b> <span>{{ form.created_at }}</span></div>
        <div class="sidebar-card__item sidebar-card__item--between"><b>Кем создано</b> <span>{{ form.created_name }}</span></div>
        <div class="sidebar-card__item sidebar-card__item--between"><b>Дата обновления</b> <span>{{ form.updated_at }}</span></div>
        <div class="sidebar-card__item sidebar-card__item--between"><b>Кем обновлено</b> <span>{{ form.updated_name || '-' }}</span></div>
      </div>
    </SidebarManage>
  </div>
</template>

<script>
import SidebarManage from '@/components/SidebarManage'

export default {
  name: 'ProgramEdit',
  components: { SidebarManage },

  data() {
    return {
      // ✅ СТРОГИЙ СПИСОК: точные официальные названия (нормализованные)
      allowedExactNames: [
        'федеральная программа рсм поддержки и развития молодежного творчества студвесна (российская студенческая весна)',
        'федеральная программа рсм развития социальной и гражданской активности молодежи молодежное самоуправление',
        'федеральная программа рсм выявления и поддержки лидеров в молодежной среде студент и ученик года',
        'федеральная программа рсм поддержки агромолодежи я в агро',
        'корпоративная программа рсм команда рсм'
      ],
      form: {
        program: [],
        ro_programs: ''
      },
      manage: {},
      loading: false,
      show_sidebar: false,
      programs: [],
      status_options: []
    }
  },

  computed: {
    userRegion() { return this.$store.state.organization },
    userRole() { return this.$store.state.userRole }
  },

  mounted() {
    this.fetchForm()
    this.loadPrograms()
    if (this.userRole === 'admin') this.loadStatuses()
  },

  methods: {
    // Нормализация строки для точного сравнения
    normalize(str) {
      return (str || '').toLowerCase().replace(/[«»"'']/g, '').replace(/\s+/g, ' ').trim()
    },

    // Проверка: входит ли программа в разрешённый список
    isAllowedProgram(programName) {
      const normName = this.normalize(programName)
      return this.allowedExactNames.some(allowed => normName === allowed || normName.includes(allowed))
    },

    // Загрузка и фильтрация программ
    async loadPrograms() {
      try {
        const response = await this.$store.dispatch('program/GET_SELECT')
        const rawItems = response.data?.results || response.data?.programs || response.data || []
        
        const filtered = rawItems.filter(p => this.isAllowedProgram(p.name))
        this.programs = filtered.filter((p, i, self) => i === self.findIndex(t => t.id === p.id))
        
        console.log('✅ Loaded programs:', this.programs.length)
      } catch (err) {
        console.error('❌ Error loading programs:', err)
        this.$notify({ type: 'error', title: 'Ошибка', text: 'Не удалось загрузить список программ' })
      }
    },

    // Загрузка статусов
    async loadStatuses() {
      try {
        const res = await this.$store.dispatch('status/GET_LIST', {})
        this.status_options = res.data?.results || res.data || []
      } catch (err) { console.warn('⚠️ Statuses:', err) }
    },

    // Загрузка данных формы
    fetchForm() {
      this.$store.dispatch('program/GET_DATA', this.$route.params.id).then(res => {
        this.form = { ...this.form, ...res.data }
        if (!Array.isArray(this.form.program)) this.form.program = []
        const { status, comment_tech, comment_cancel } = res.data
        this.manage = { status, comment_tech, comment_cancel }
      }).catch(() => this.$notify({ type: 'error', title: 'Ошибка!', text: 'Ошибка получения данных' }))
    },

    // Отправка формы
    async onSendForm(saveType = '') {
      if (saveType) this.form.status = saveType
      this.loading = true
      
      
      const payload = {
        year: this.form.year,
        region_org: this.form.region_org || this.userRegion?.id || this.userRegion,
        status: this.form.status || 'draft',
        program: this.form.program,
        ro_programs: this.form.ro_programs || null,
        comment_tech: this.form.comment_tech || null,
        comment_cancel: this.form.comment_cancel || null
      }

      console.log('📤 Sending payload:', JSON.stringify(payload, null, 2))

      try {
        await this.$store.dispatch('program/PATCH_DATA', { id: this.$route.params.id, data: payload })
        this.loading = false
        this.$router.push({ name: 'program' })
        this.$notify({ type: 'success', title: 'Успех!', text: 'Изменения сохранены.' })
      } catch (error) {
        this.loading = false
        console.error('❌ Backend error:', {
          status: error?.response?.status,
          data: error?.response?.data
        })
        
        let errorMsg = 'Ошибка сохранения изменений.'
        if (error?.response?.status === 500) {
          errorMsg = 'Ошибка сервера. Поле "ro_programs" ещё не добавлено в базу.'
        } else if (error?.response?.status === 409 || error?.response?.data?.non_field_errors) {
          errorMsg = 'Запись с таким годом и организацией уже существует.'
        } else if (error?.response?.data && typeof error.response.data === 'object') {
          const messages = Object.values(error.response.data).flat?.().filter(Boolean) || []
          if (messages.length) errorMsg = messages.join('\n')
        }
        
        this.$notify({ type: 'error', title: 'Ошибка!', text: errorMsg })
      }
    },

    // Отправка изменений из sidebar (только админ)
    sendManage() {
      const payload = { ...this.form, ...this.manage }
      this.$store.dispatch('program/PATCH_DATA', { id: this.$route.params.id, data: payload }).then(() => {
        this.$notify({ type: 'success', title: 'Успех!', text: 'Изменения сохранены.' })
      }).catch(err => {
        const msg = err?.response?.data?.non_field_errors?.[0] || 'Ошибка сохранения данных.'
        this.$notify({ type: 'error', title: 'Ошибка!', text: msg })
        console.error('❌ Manage error:', err)
      })
    },

    openSidebar() { this.show_sidebar = true }
  }
}
</script>

<style scoped>
.form__empty {
  padding: 1rem;
  text-align: center;
  color: #6c757d;
  background: #f8f9fa;
  border-radius: 4px;
}
</style>